const HelperModal = () => {
  return (
    <div className="bg-white font-thin font-ShinMaruGo text-xl w-full py-6 text-candy-pink text-center">
      <p>
        交換ポイントの還元値は
        <br />
        素材アイテムのレアリティ
        <br />
        によって違うコケ！
      </p>
      <div className="my-6 flex justify-center">
        <div className="text-left">
          <p>R = 5pt</p>
          <p>SR = 20pt</p>
          <p>SSR = 100pt</p>
        </div>
      </div>
      <p>
        余った交換ポイントは
        <br />
        次回の交換でまた使えるシン♪
      </p>
    </div>
  )
}

export default HelperModal
